enum SchedulePreset {
  NEXT_WEEK = "nextWeek",
  TODAY = "today",
  TOMORROW = "tomorrow",
}

export default SchedulePreset;
